<template>
    <div>
        <v-container fluid>
            <v-card class="pb-2 mb-3">
                <v-card-title>{{ $t("SwissLLMSettings") }}</v-card-title>
                <v-card-text class="pb-2">
                    <v-row justify="center" align="center" v-if="loading">
                        <div class="text-center">
                            <div>
                                <v-progress-circular class="my-4" :size="50" width="5" color="primary"
                                    indeterminate></v-progress-circular>
                            </div>
                            <p class="display-1">{{ $t("Loading") }}...</p>
                        </div>
                    </v-row>
                    <v-row  v-if="!loading">
                        <v-col cols="1"></v-col>
                        <v-col cols="2" class="pb-0">
                            <p class="ma-0 pb-0">{{ $t("UseOnPrompt") }}</p>
                        </v-col>
                        <v-col cols="3" class="pb-0">
                            <p class="ma-0 pb-0">{{ $t("AdditionalNotes") }}</p>
                        </v-col>
                        <v-col cols="5">

                        </v-col>
                    </v-row>
                    <v-row v-if="!loading">
                        <v-col>
                            <div v-for="(item, i) in contentTypeFields" :key="i">
                                <content-type-fields-infomaniak-component :field="item" @addToPrompt="addToTextArea"
                                    @removeFromPrompt="removeFromTextArea"
                                    @addAdditionalNotes="addAdditionalNotesToTextArea"
                                    :refresh="refresh"></content-type-fields-infomaniak-component>
                            </div>
                            <div class="mt-3 row">
                                <v-combobox
                                auto-select-first
                                class="col"
                                :label="$t('Model')"
                                :items="availableModels"
                                v-model="selectedModel"
                                @blur="setNewModelValue($event.target.value)"
                                :menu-props="{ closeOnContentClick: false }"
                                >
                                </v-combobox>
                            </div>
                        </v-col>
                        <v-col>
                            <v-textarea v-model="prompt" rows="10" filled append-outer-icon="mdi-refresh"
                                @click:append-outer="refreshData" @input="manualChange = true"></v-textarea>
                            <v-row align="center">
                                <v-col cols="6">
                                    <div class="d-flex align-center">
                                        <v-file-input lang="Select a file to test" truncate-length="15" v-model="selectedFile"></v-file-input>
                                    </div>
                                </v-col>
                                <v-col cols="3">
                                    <div class="d-flex align-center">
                                        <v-btn color="primary" small :loading="loadingModal" @click="performTest()">
                                            {{ $t("TestRecognition") }}
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col>
                                    <div class="d-flex align-center">
                                        <v-btn @click="saveSettings()" color="success">
                                            {{ $t("Save") }}
                                        </v-btn>
                                        <v-btn @click="cancel()">
                                            {{ $t("Cancel") }}
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

        </v-container>
        <infomaniak-results-modal :loading="loadingModal" :ref="modalKey" :results="performValues"></infomaniak-results-modal>
    </div>
</template>

<script>
import ContentTypeService from "@/services/ContentTypeService";
import ContentTypeFieldsInfomaniakComponent from "@/components/administration/contentType/documentIntelligence/infomaniak/ContentTypeFieldsInfomaniakComponent.vue";
import DocumentIntelligenceProvidersService from "@/services/DocumentIntelligenceProvidersService.js";
import Utils from "@/ecm/common/Utils";
import DocumentIntelligenceProvidersSettings from "@/ecm/models/contentType/documentIntelligence/DocumentIntelligenceProvidersSettings.js";
import InfomaniakResultsModal from "./InfomaniakResultsModal.vue";
export default {
    components: {
        ContentTypeFieldsInfomaniakComponent,
        InfomaniakResultsModal
    },
    async created() {
        this.loading = true;
        this.documentIntelligenceProviderSettings = this.documentIntelligenceProviderSettings.toDto();
        this.loadContentTypeConfig(this.contentTypeId)
        this.loadModels();
    },
    data() {
        return {
            loading: false,
            contentTypeId: this.$route.params.contentTypeID,
            settingID: this.$route.params.settingID,
            contentTypeFields: [],
            documentIntelligenceProviderSettings: new DocumentIntelligenceProvidersSettings(),
            fieldsCodes: [],
            fieldsToPrompt: [],
            prompt: "",
            jsonFormat: [],
            refresh: false,
            manualChange: false,
            performValues: [],
            showResultsModal: false,
            modalKey: "modalKey",
            selectedFile: null,
            loadingModal : false,
            availableModels: [],
            selectedModel: ""
        };
    },
    computed: {
      modalInstance() {
        return this.$refs[this.modalKey];
      },
    },
    methods: {
        loadContentTypeConfig(contentTypeId) {
            ContentTypeService.getFields(contentTypeId).then((data) => {
                if (this.settingID != 0) {
                    this.getSettingsById(this.settingID, data);
                }
                else {
                    for (var item of data) {
                        item.Selected = false;
                        item.additionalNotes = "";
                    }
                    this.contentTypeFields = data;
                    this.loadPrompt();
                    this.loading = false;
                }
            })
        },
        loadPrompt() {
            const fieldsToPromptString = this.fieldsToPrompt.map(item => {
                if (item.additionalNotes && item.additionalNotes.trim().length > 0) {
                    return item.prompt + ", " + item.additionalNotes;
                }
                return item.prompt;
            }).join('.\n').concat(this.fieldsToPrompt.length ? '.' : '');

            const jsonFormatString = this.jsonFormat.join(';').concat(this.jsonFormat.length ? ';' : '');
            this.prompt = this.$t("InfomaniakPrompt").replace("-*.MARKER_CT_FIELDS.*-", fieldsToPromptString).replace("-*.MARKER_JSON_KEYS.*-", jsonFormatString);
        },

        async getSettingsById(settingID, contentTypeFields) {
            DocumentIntelligenceProvidersService.getDocumentIntelligenceSettings(settingID)
                .then((data) => {
                    this.documentIntelligenceProviderSettings = data;
                    const jsonConfig = JSON.parse(this.documentIntelligenceProviderSettings.configJSON);
                    for (var field of contentTypeFields) {
                        const fieldInConfig = jsonConfig.fieldsConfig.find(x => x.code === field.Code);
                        if (fieldInConfig) {
                            field.Selected = true;
                            field.additionalNotes = fieldInConfig.additionalNotes;
                            this.fieldsCodes.push(field.Code);
                            var promptMapped = this.$t("InfomaniakPromptField").replace("{0}", field.Name).replace("{1}", field.Type).replace("{2}", field.Code)
                            this.fieldsToPrompt.push({prompt: promptMapped, additionalNotes: fieldInConfig.additionalNotes });
                            this.jsonFormat.push(`'${field.Code}'`);
                        }
                    }
                    this.manualChange = data.isManualPrompt;
                    this.selectedModel = data.llmModel;
                    if(this.manualChange){
                        this.prompt = this.documentIntelligenceProviderSettings.prompt;
                    }
                    else{
                        this.loadPrompt();
                    }
                    this.contentTypeFields = contentTypeFields;
                    this.loading = false;
                })
        },

        async addToTextArea(prompt, fieldCode) {
            if (this.manualChange) {
                var res = await this.$confirm(this.$t("ManualActionDetected"), {
                    title: this.$t("Confirm"),
                    icon: "mdi-alert",
                    color: "warning",
                    buttonTrueText: this.$t("Ok"),
                    buttonFalseText: this.$t("Cancel"),
                });
                if (res == 1) {
                    this.addToPrompt(prompt, fieldCode)
                    this.manualChange = false
                }
                else {
                    return
                }
            }
            else {
                this.addToPrompt(prompt, fieldCode)
            }
        },
        async removeFromTextArea(event, fieldCode) {
            if (this.manualChange) {
                var res = await this.$confirm(this.$t("ManualActionDetected"), {
                    title: this.$t("Confirm"),
                    icon: "mdi-alert",
                    color: "warning",
                    buttonTrueText: this.$t("Ok"),
                    buttonFalseText: this.$t("Cancel"),
                });
                if (res == 1) {
                    this.removeFromPrompt(event, fieldCode)
                    this.manualChange = false
                }
                else {
                    return
                }
            }
            else {
                this.removeFromPrompt(event, fieldCode)
            }
        },
        async addAdditionalNotesToTextArea(event, additionalNotes) {
            if (this.manualChange) {
                var res = await this.$confirm(this.$t("ManualActionDetected"), {
                    title: this.$t("Confirm"),
                    icon: "mdi-alert",
                    color: "warning",
                    buttonTrueText: this.$t("Ok"),
                    buttonFalseText: this.$t("Cancel"),
                });
                if (res == 1) {
                    this.addAdditionalNotes(event, additionalNotes)
                    this.manualChange = false
                }
                else {
                    return
                }
            }
            else {
                this.addAdditionalNotes(event, additionalNotes)
            }
        },
        addToPrompt(prompt, fieldCode) {
            this.refresh = false;
            this.fieldsToPrompt.push({prompt: prompt, additionalNotes: '' });
            this.jsonFormat.push(`'${fieldCode}'`);
            this.fieldsCodes.push(fieldCode)
            this.loadPrompt();
        },
        removeFromPrompt(event, fieldCode) {
            const index = this.fieldsToPrompt.findIndex(linea => linea.prompt.includes(event));
            const indexJson = this.jsonFormat.findIndex(linea => linea.includes(fieldCode));
            const indexFiledsCodes = this.fieldsCodes.findIndex(field => field === fieldCode);
            if (index !== -1) {
                this.fieldsToPrompt.splice(index, 1);
            }
            if (indexJson !== -1) {
                this.jsonFormat.splice(indexJson, 1);
            }
            if (indexFiledsCodes !== -1) {
                this.fieldsCodes.splice(indexFiledsCodes, 1);
            }
            this.loadPrompt();
        },
        addAdditionalNotes(event, additionalNotes) {
            const index = this.fieldsToPrompt.findIndex(linea => linea.prompt.includes(event));
            if (index !== -1) {
                if (additionalNotes.trim() === "") {
                    this.fieldsToPrompt[index].additionalNotes = "";
                } else {
                    this.fieldsToPrompt[index].additionalNotes = additionalNotes.toLowerCase();
                }
            }
            this.loadPrompt();
        },
        async refreshData() {
            var res = await this.$confirm(this.$t("RefreshData"), {
                title: this.$t("Confirm"),
                icon: "mdi-alert",
                color: "warning",
                buttonTrueText: this.$t("Ok"),
                buttonFalseText: this.$t("Cancel"),
            });
            if (res == 1) {
                this.fieldsToPrompt = [];
                this.jsonFormat = [];
                this.loadPrompt();
                this.refresh = true;
                this.manualChange = false
            }
            else {
                return
            }

        },
        saveSettings() {
            this.loading = true;
            var fieldsConfig = [];
            for (var field of this.contentTypeFields) {
                if(!field.Selected) continue;
                fieldsConfig.push({
                    code: field.Code,
                    additionalNotes: field.additionalNotes
                });
            }

            var jsonString = JSON.stringify({
                fieldsConfig: fieldsConfig,
                language: "en",
            });

            this.documentIntelligenceProviderSettings.Id = parseInt(this.settingID);
            this.documentIntelligenceProviderSettings.ContentTypeID = parseInt(this.contentTypeId);
            this.documentIntelligenceProviderSettings.DocumentIntelligenceProviderID = 3;
            this.documentIntelligenceProviderSettings.Prompt = this.prompt;
            this.documentIntelligenceProviderSettings.ConfigJSON = jsonString;
            this.documentIntelligenceProviderSettings.IsManualPrompt = this.manualChange;
            this.documentIntelligenceProviderSettings.LLMModel = this.selectedModel;
            DocumentIntelligenceProvidersService.SaveContentTypeDocumentIntelligenceProviderAsync(this.documentIntelligenceProviderSettings)
                .then((data) => {
                    Utils.toast.success(this.$t("DocumentIntelligenceProviderSettings") + " " + this.$t("OperationSuccess"));
                })
                .catch((error) => {
                    Utils.toast.error(this.$t(error));
                })
                .then(() => {
                    this.$router.push(`/administration/content-type/document-intelligence-settings/${this.contentTypeId}`)
                    this.loading = false;
                })
        },
        cancel() {
            this.$router.push({ path: `/administration/content-type/document-intelligence-settings/${this.contentTypeId}` });
        },
        hideModal() {
          this.showResultsModal = false;
        },
        async performTest() {
            if (!this.fieldsCodes || this.fieldsCodes.length === 0) {
                Utils.toast.error(this.$t("FieldsRequired"));
                return;
            }

            if (this.selectedFile) {
                this.cleanResults();
                this.loadingModal = true;

                let performTestRequest = {
                    prompt: this.prompt,
                    Fields: this.contentTypeFields.filter((x) => x.Selected),
                    Base64File: await this.getBase64UploadedFile(),
                    LLMModel: this.selectedModel
                };

                DocumentIntelligenceProvidersService.performInfomaniakLLMTest(performTestRequest)
                .then((data) => {
                    this.performValues = data;
                    this.loadingModal = false;
                    this.modalInstance.showModal();
                })
                .catch((error) => {
                    this.loadingModal = false;
                });

            } else {
                Utils.toast.error(this.$t("DocumentAttachmentRequired"));
                return;
            }
        },
        async getBase64UploadedFile() {
          let base64 = Utils.file.toBase64(this.selectedFile);
          return base64;
        },
        cleanResults() {
          this.performValues = null;
        },
        loadModels() {
        DocumentIntelligenceProvidersService.getLLMModels(3).then((data) => {
            this.availableModels = data;
        });
    },
    setNewModelValue(value) {
      this.selectedModel = value;
    },
  },
}

</script>
